import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PortalDirection } from 'models/commonModel';

export const useLanguage = () => {
    const { i18n } = useTranslation();

    const language = i18n.language;
    const direction = i18n.dir(language);

    const changeLanguage = async (newLang: string) => {
        i18n.changeLanguage(newLang)
    };

    const detectDirection = (): PortalDirection => {
        // List of RTL languages
        const rtlLanguages = ['ar', 'he', 'fa', 'ur', 'ps', 'yi'];

        // Detect the browser's language
        const browserLang = navigator.language || 'en';

        // Extract the base language (e.g., 'ar' from 'ar-SA')
        const langCode = browserLang.split('-')[0];

        // Check if the language is RTL
        const isRTL = rtlLanguages.includes(langCode);

        return isRTL ? 'rtl' : 'ltr';
    };

    useEffect(() => {
        //  Detects the browser language
        const detectedDirection = detectDirection();
        document.documentElement.setAttribute('dir', detectedDirection);
        document.documentElement.setAttribute('lang', navigator.language || 'en');
    }, [])

    useEffect(() => {
        // Set HTML direction and language attribute
        document.documentElement.setAttribute('dir', direction);
        document.documentElement.setAttribute('lang', language);

    }, [direction, language])   // If user have previously changed lang (cached in localStorage), then it will overwrite the detected lang

    return { language, direction, changeLanguage };
}